import { PenLine } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BlogDashboardHero() {
  const navigate = useNavigate();
  return (
   <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8">
      <div
        className="relative rounded-2xl sm:rounded-3xl overflow-hidden h-[300px] flex items-center justify-center text-center px-4"
        style={{
          backgroundImage: "url('/img/blog/Travel-background.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-3xl mx-auto translate-y-12">
          <h1 className="text-white font-bold text-2xl sm:text-3xl md:text-[32px] leading-tight">
            Share Your Travel Stories{" "}
            <span className="font-extrabold">Inspire the World</span>
          </h1>
 
          <p className="text-white/85 text-sm mt-2 max-w-xl mx-auto">
            Write authentic travel experiences and help millions of travelers
            plan better trips.
          </p>
 
          <button
            onClick={() => navigate("/dashboard/create-blog")}
            className="mt-4 inline-flex items-center gap-2 bg-[#7209B7] hover:bg-[#560ca3] transition-colors text-white text-sm font-semibold px-6 py-2 rounded-full"
          >
            <PenLine className="w-4 h-4" />
            Write New Blog
          </button>
        </div>
      </div>
    </section>
  );
}